/**
 * @generated SignedSource<<53c9c197be3efdfdcc5598ba934f1d09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
export type UpdateIntegrationInput = {
  credentials: string;
  description?: string | null | undefined;
  integrationId?: any | null | undefined;
  integrationType: IntegrationType;
};
export type TemporalIntegrationFormUpdateIntegrationMutation$variables = {
  input: UpdateIntegrationInput;
};
export type TemporalIntegrationFormUpdateIntegrationMutation$data = {
  readonly updateIntegration: {
    readonly error: string | null | undefined;
    readonly integration: {
      readonly credentials: any;
      readonly id: any;
      readonly integrationType: IntegrationType;
      readonly name: string;
    } | null | undefined;
  };
};
export type TemporalIntegrationFormUpdateIntegrationMutation = {
  response: TemporalIntegrationFormUpdateIntegrationMutation$data;
  variables: TemporalIntegrationFormUpdateIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIntegrationPayload",
    "kind": "LinkedField",
    "name": "updateIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLIntegration",
        "kind": "LinkedField",
        "name": "integration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "integrationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "credentials",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TemporalIntegrationFormUpdateIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TemporalIntegrationFormUpdateIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ea19a98dd311560bf4e95278c7ed1128",
    "id": null,
    "metadata": {},
    "name": "TemporalIntegrationFormUpdateIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation TemporalIntegrationFormUpdateIntegrationMutation(\n  $input: UpdateIntegrationInput!\n) {\n  updateIntegration(input: $input) {\n    integration {\n      id\n      name\n      integrationType\n      credentials\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "3cf3a834ce5152f96a294479a03b2d3c";

export default node;
